export var MenuItemType;

(function (MenuItemType) {
  MenuItemType["externalLink"] = "externalLink";
  MenuItemType["withSubMenus"] = "withSubMenus";
  MenuItemType["leavesLevel"] = "leavesLevel";
  MenuItemType["group"] = "group";
})(MenuItemType || (MenuItemType = {}));

export var MenuID;

(function (MenuID) {
  MenuID["clinic"] = "clinic";
  MenuID["statistic"] = "statistic";
  MenuID["cofit_pro"] = "cofit_pro";
  MenuID["cg_report"] = "cg_report";
  MenuID["analysisGuide"] = "/analysis_guide";
  MenuID["analysisGuideTarget"] = "/analysis_guide/target";
  MenuID["analysisGuideDiet"] = "/analysis_guide/diet";
  MenuID["instantFoodTool"] = "/instant_food_tool";
  MenuID["info_mgmt"] = "/info_mgmt";
  MenuID["inventory"] = "/inventory";
  MenuID["onboard"] = "/onboard";
  MenuID["daily_inventory"] = "/daily_inventory";
  MenuID["measurement_mgmt"] = "/measurement_mgmt";
  MenuID["client_mgmt"] = "/client_mgmt";
  MenuID["chatroom"] = "/chatroom";
  MenuID["deliverynote"] = "/deliverynote";
  MenuID["stock_news"] = "/stock_news";
  MenuID["restock_add"] = "/restock_add";
  MenuID["restock_list"] = "/restock_list";
  MenuID["client"] = "/client";
  MenuID["client_list"] = "/client_list";
  MenuID["reservation"] = "/";
  MenuID["order"] = "/client/order";
  MenuID["catalog"] = "catalog";
  MenuID["corelist"] = "corelist";
  MenuID["supplierlist"] = "supplierlist";
  MenuID["dispensationOrder"] = "/deliverynote/order";
  MenuID["_3DModel"] = "/3DModel";
  MenuID["login"] = "/login";
})(MenuID || (MenuID = {}));

export var SummaryPageType;

(function (SummaryPageType) {
  SummaryPageType["edit"] = "edit";
  SummaryPageType["list"] = "list";
  SummaryPageType["create"] = "create";
})(SummaryPageType || (SummaryPageType = {}));